// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"446":"8e52ac78","938":"6cde29a0"}[chunkId] + ".css";
};